export default [
    {
        value: "宁夏",
        label: "宁夏",
        children: [
            {
                value: "银川",
                label: "银川",
                children: [{ value: "兴庆区", label: "兴庆区" }, { value: "西夏区", label: "西夏区" }, {
                    value: "金凤区",
                    label: "金凤区"
                }, { value: "灵武市", label: "灵武市" }, { value: "永宁县", label: "永宁县" }, { value: "贺兰县", label: "贺兰县" }],

            },
            {
                value: "石嘴山",
                label: "石嘴山",
                children: [{ value: "大武口区", label: "大武口区" }, { value: "惠农区", label: "惠农区" }, {
                    value: "平罗县",
                    label: "平罗县"
                }],

            },
            {
                value: "吴忠",
                label: "吴忠",
                children: [{ value: "利通区", label: "利通区" }, { value: "红寺堡区", label: "红寺堡区" }, { value: "青铜峡市", label: "青铜峡市" }, {
                    value: "盐池县",
                    label: "盐池县"
                }, { value: "同心县", label: "同心县" }],

            },
            {
                value: "固原",
                label: "固原",
                children: [{ value: "原州区", label: "原州区" }, { value: "西吉县", label: "西吉县" }, {
                    value: "隆德县",
                    label: "隆德县"
                }, { value: "泾源县", label: "泾源县" }, { value: "彭阳县", label: "彭阳县" }],

            },
            {
                value: "中卫",
                label: "中卫",
                children: [{ value: "沙坡头区", label: "沙坡头区" }, { value: "中宁县", label: "中宁县" }, {
                    value: "海原县",
                    label: "海原县"
                }],

            },
            {
                value: "银川经开区",
                label: "银川经开区",
                children:[
                    { value: "银川经开区", label: "银川经开区" }
                ]
            },
            {
                value: "宁东管委会",
                label: "宁东管委会",
                children:[
                    { value: "宁东管委会", label: "宁东管委会" }
                ]
            }
        ]

    }
]


// WEBPACK FOOTER //
// ./src/utils/ningxia.js